import React from 'react'
import parse from 'html-react-parser'
import { Fade } from 'react-reveal'

const AgentsHeader = ({title}) => {
  return (
    <section className='agents-header'>
      <Fade bottom distance='40px'>
        <div className='agents-header__inner'>
          { title && <h1>{parse(title)}</h1> }
        </div>
      </Fade>
    </section>
  )
}

export default AgentsHeader